import React from 'react'
import { Box, Typography, Stack } from '@mui/material'
// import EmailIcon from '@mui/icons-material/Email';
// import PhoneIcon from '@mui/icons-material/Phone';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/CallOutlined';
import LocationIcon from '@mui/icons-material/LocationOnOutlined';

const FooterContact = ({ contactData, theme }) => {
  const contactItems = [
    { icon: <EmailIcon />, key: "email" },
    { icon: <PhoneIcon />, key: "phone" },
    { icon: <LocationIcon />, key: "location" },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1.5 }}>
        <Box sx={{ width: 24, height: 2, bgcolor: theme.palette.primary.main }} />
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ 
            color: theme.palette.common.white,
            fontFamily: theme.typography.h3.fontFamily
        }}
        >
          {contactData.title}
        </Typography>
      </Box>

      <Stack spacing={3}>
        {contactItems.map((item, i) => (
          <Box key={i} sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
            <Box
              sx={{
                p: 1,
                borderRadius: "0.75rem",
                bgcolor: "rgba(255, 255, 255, 0.05)",
                color: theme.palette.custom.footerText,
                display: "flex",
              }}
            >
              {item.icon}
            </Box>

            <Box>
              <Typography
                variant="textXs"
                sx={{
                  color: theme.palette.custom.footerText,
                  display: "block",
                  mb: 0.5,
                }}
              >
                {contactData[item.key].label}
              </Typography>

              <Typography
                variant="textSm"
                sx={{ 
                    color: theme.palette.custom.footerText,
                    "&:hover": {
                        color: theme.palette.custom.footerLinkHover,
                    },
                }}
              >
                {contactData[item.key].value}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default FooterContact
